export const entranceExamCategories = [
  {
    icon: undefined, // Icon will be set in the page file
    title: 'Entrance Exams',
    description: 'Comprehensive test series for agricultural entrance examinations',
    exams: [
      {
        id: 'icar-aieea-pg-agronomy',
        title: 'ICAR AIEEA PG Agronomy',
        type: 'entrance',
        lastDateToApply: '2024-03-31'
      },
      {
        id: 'icar-aieea-pg-horticulture',
        title: 'ICAR AIEEA PG Horticulture',
        type: 'entrance',
        lastDateToApply: '2024-03-31'
      },
      {
        id: 'cuet-pg-agriculture',
        title: 'CUET PG Agriculture',
        type: 'entrance',
        lastDateToApply: '2024-02-15'
      },
      {
        id: 'cuet-pg-horticulture',
        title: 'CUET PG Horticulture',
        type: 'entrance',
        lastDateToApply: '2024-02-15'
      },
      {
        id: 'rajasthan-pre-pg-agriculture',
        title: 'Rajasthan Pre-PG Agriculture',
        type: 'entrance',
        lastDateToApply: '2024-04-15'
      },
      {
        id: 'rajasthan-pre-pg-horticulture',
        title: 'Rajasthan Pre-PG Horticulture',
        type: 'entrance',
        lastDateToApply: '2024-04-15'
      }
    ]
  }
];
